import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

//ANT DESIGN IMPORTS
import {
    Input,
    Row,
    Card,
    Form,
    Select,
    Col,
    Divider,
    Spin,
    DatePicker,
    Button,
    Typography,
    Collapse
} from "antd";

//ANT DESIGN ICONS IMPORT
import {
    LeftOutlined,
    MinusOutlined,
    PlusOutlined
} from "@ant-design/icons";

//OTHER IMPORTS
import dayjs from 'dayjs';

//PROJECT IMPORTS
import { BOM } from "../../../../../services/definedMethod";
import cnt from "../../../../../services/definedConstant";
import CustomButton from "../../../../../components/custom/CustomButton";
import MainLayout from "../../../../../components/layouts/MainLayout";
import TopContent from "../../../../../components/layouts/TopContent";
import { apiConfig, labelConfig, staticConfig } from "../../../customer.config";
import { accountStatus } from "../../../../../components/facilities/AccountFacility";
import { showCheckerApprovalModal } from "../../../../../components/CheckerModal";


const PrematureCloseRecurringDepositAcc = (props) => {
    const { TextArea } = Input;
    const { userData } = props;
    const { session } = userData;
    const { Text } = Typography;
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const { state } = useLocation();
    const [isLoading, setIsLoading] = useState(false);
    const [isDateSubmitted, setIsDateSubmitted] = useState(false);
    const [isTransferToSavingsSelected, setIsTransferToSavingsSelected] = useState(false);
    const [actionOptions, setActionOptions] = useState([]);
    const [transferToSavingsOptions, setTransferToSavingsOptions] = useState([]);
    const [onAccountClosureId, setOnAccountClosureId] = useState();
    const [paymentTypeData, setPaymentTypeData] = useState([]);
    const [ghost, setGhost] = useState(null)
    const dateFormat = 'YYYY/MM/DD';

    const Items = [
        {
            key: "1",
            label: "Show Payment Details",
            children: (
                <>
                    <Row style={{ justifyContent: "spacebetween", marginTop: "15px" }}>
                        <Col span={8} style={{ padding: "0px 8px" }}>
                            <Form.Item
                                name="accountNumber"
                                label={
                                    <Text style={{ fontSize: "16px" }}>
                                        {labelConfig.accountNumber}
                                    </Text>
                                }
                            >
                                <Input
                                    placeholder={BOM.handlePlaceholderMsg(
                                        labelConfig.accountNumber,
                                        labelConfig.pleaseEnter
                                    )}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={8} style={{ padding: "0px 8px" }}>
                            <Form.Item
                                name="checkNumber"
                                label={
                                    <Text style={{ fontSize: "16px" }}>
                                        {labelConfig.chequeNumber}
                                    </Text>
                                }
                            >
                                <Input
                                    placeholder={BOM.handlePlaceholderMsg(
                                        labelConfig.chequeNumber,
                                        labelConfig.pleaseEnter
                                    )}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={8} style={{ padding: "0px 8px" }}>
                            <Form.Item
                                name="routingCode"
                                label={
                                    <Text style={{ fontSize: "16px" }}>
                                        {labelConfig.routingCode}
                                    </Text>
                                }
                            >
                                <Input
                                    placeholder={BOM.handlePlaceholderMsg(
                                        labelConfig.routingCode,
                                        labelConfig.pleaseEnter
                                    )}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={8} style={{ padding: "0px 8px" }}>
                            <Form.Item
                                name="receiptNumber"
                                label={
                                    <Text style={{ fontSize: "16px" }}>
                                        {labelConfig.receiptNumber}
                                    </Text>
                                }
                            >
                                <Input
                                    placeholder={BOM.handlePlaceholderMsg(
                                        labelConfig.receiptNumber,
                                        labelConfig.pleaseEnter
                                    )}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={8} style={{ padding: "0px 8px" }}>
                            <Form.Item
                                name="bankNumber"
                                label={
                                    <Text style={{ fontSize: "16px" }}>{labelConfig.bank}</Text>
                                }
                            >
                                <Input
                                    placeholder={BOM.handlePlaceholderMsg(
                                        labelConfig.bank,
                                        labelConfig.pleaseEnter
                                    )}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </>
            ),
        },
    ];

    useEffect(() => {
        defaultDate()
    }, []);

    function onCancel() {
        navigate("/detail-recurring-deposit-account", { state: state });
    }
    const defaultDate = () => {
        form.setFieldsValue({
            closedOnDate: dayjs(),
        })
    }
    const disabledAfterCurrentDate = (current) => {
        return current && current.valueOf() > Date.now();
    };
    const handleOnChange = (value, option) => {

        //DO NOT REMOVE THE VALUE PARAMETER EVEN IF IT IS NOT USED OTHERWISE IT WILL NOT WORK
        if (option?.label.toLowerCase() === "transfer to savings") {
            setIsTransferToSavingsSelected(true)
        } else {
            setIsTransferToSavingsSelected(false)
        };
        setOnAccountClosureId(value)

    }
    const preOnSubmit = (formValues) => {

        const params = {
            command: "calculatePrematureAmount",
        };
        const url = `${apiConfig.Recurringdepositaccounts}/${state.id}`;
        let body = {
            closedOnDate: BOM.DateTime(
                formValues.closedOnDate,
                "only-date"
            ),
            dateFormat: "dd MMMM yyyy",
            locale: "en",
            session,
            method: "POST",
            params,
        };
        setIsLoading(true);
        BOM.FetchReqAction(body, url, (err, res) => {
            if (err) {
                BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
                setIsLoading(false);
            } else {
                const objDetail = res;
                setIsDateSubmitted(true)

                let tempActionOptions = [];
                let tempTranferToSavingsOptions = [];
                let tempPaymentType = [];

                objDetail?.onAccountClosureOptions?.forEach((element) => {
                    tempActionOptions.push({
                        value: element.id,
                        label: element.value,
                    });
                });
                objDetail?.paymentTypeOptions?.forEach((element) => {
                    tempPaymentType.push({
                        value: element.id,
                        label: element.name,
                    });
                });

                objDetail?.savingsAccounts?.forEach((element) => {
                    tempTranferToSavingsOptions.push({
                        value: element.id,
                        label: element.accountNo,
                    });
                });

                form.setFieldsValue({
                    maturityAmount: objDetail?.maturityAmount ? objDetail?.maturityAmount : " - ",
                    onAccountClosureId: objDetail?.onAccountClosureOptions[0].value
                        ? objDetail?.onAccountClosureOptions[0].value
                        : " - ",
                })
                setOnAccountClosureId(objDetail?.onAccountClosureOptions[0].id);
                setActionOptions(tempActionOptions);
                setPaymentTypeData(tempPaymentType);
                setTransferToSavingsOptions(tempTranferToSavingsOptions)
                setIsLoading(false);
            }
        });

    };
    const onSubmit = (formValues) => {

        const url = `${apiConfig.Recurringdepositaccounts}/${state.id}`;
        const params = {
            command: "prematureClose",
        };

        let body = {
            closedOnDate: BOM.DateTime(
                formValues.closedOnDate,
                "only-date"
            ),
            onAccountClosureId: onAccountClosureId,
            toSavingsAccountId: formValues.transferToSavings,
            note: formValues.note,
            transferDescription: formValues.transferDescription,
            dateFormat: "dd MMMM yyyy",
            locale: "en",
            session,
            method: "POST",
            params,
        };
        setIsLoading(true);
        BOM.FetchReqAction(body, url, (err, res) => {
            if (err) {
                BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
                setIsLoading(false);
            } else {
                BOM.AlertMsg(cnt.SUCCESS, labelConfig.prematureCloseRecurringDepositMsg);
                navigate("/detail-recurring-deposit-account", {
                    state: { ...state, statusValue: accountStatus.prematureClosed },
                });
                //STOP LOAD
                setIsLoading(false);
            }
        }, {
                navigate,
                showCheckerModal: showCheckerApprovalModal,
                onCheckerApproval: (res) => {
                  navigate("/detail-recurring-deposit-account", {
                    state: { ...state, statusValue: accountStatus.prematureClosed },
                });
                  setIsLoading(false);
                },
              });

    };

    return (
        <MainLayout isEnableRightSidebar={true}>
            <TopContent
                pageTitle={labelConfig.prematureCloseRecurringDeposit}
                pageItems={staticConfig.prematureCloseRecurringDepositAccountBreadcrumbItems}
            />

            <Spin spinning={isLoading} size="large">
                <Card
                    headStyle={{ borderBottomWidth: 0 }}
                    style={{
                        boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
                        borderRadius: 20,
                    }}
                    title={
                        <Row
                            style={{
                                alignContent: "center",
                                width: "8%",
                            }}
                        >
                            <Button
                                icon={<LeftOutlined />}
                                type="text"
                                style={{
                                    marginTop: "auto",
                                    marginBottom: "auto",
                                }}
                                onClick={onCancel}
                            >
                                <Text
                                    style={{ marginTop: "auto", marginBottom: "auto", fontSize: 15 }}
                                >
                                    Back
                                </Text>
                            </Button>
                        </Row>
                    }
                >
                    <Form form={form} layout="vertical" onFinish={isDateSubmitted ? onSubmit : preOnSubmit}>
                        <Row>
                            <Divider orientation="left">{`Account No: ${state.accountNo}`}</Divider>
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.closedOn}
                                    name="closedOnDate"
                                    rules={[
                                        {
                                            required: true,
                                            message: BOM.CheckReqFld(labelConfig.premClosedDate),
                                        },
                                    ]}
                                >
                                    <DatePicker
                                        disabledDate={disabledAfterCurrentDate}
                                        style={{ width: "100%", height: 35 }}
                                        format={dateFormat}
                                    />
                                </Form.Item>
                            </Col>
                            {isDateSubmitted &&
                                <>
                                    <Col span={8} style={{ padding: "0px 8px" }}>
                                        <Form.Item
                                            label={labelConfig.action}
                                            name="onAccountClosureId"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: BOM.CheckReqFld(labelConfig.action),
                                                },
                                            ]}
                                        >
                                            <Select
                                                filterOption={(input, option) =>
                                                    (option?.label?.toLowerCase() ?? "").includes(
                                                        input?.toLowerCase()
                                                    )
                                                }
                                                placeholder={BOM.handlePlaceholderMsg(
                                                    labelConfig.action,
                                                    "select"
                                                )}
                                                options={actionOptions}
                                                showSearch
                                                onChange={handleOnChange}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col span={8} style={{ padding: "0px 8px" }}>
                                        <Form.Item
                                            label={labelConfig.paymentTypes}
                                            name="paymentTypeId"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: BOM.CheckReqFld(labelConfig.paymentTypes),
                                                },
                                            ]}
                                        >
                                            <Select
                                                filterOption={(input, option) =>
                                                    (option?.label?.toLowerCase() ?? "").includes(
                                                        input?.toLowerCase()
                                                    )
                                                }
                                                placeholder={BOM.handlePlaceholderMsg(
                                                    labelConfig.paymentTypes,
                                                    "select"
                                                )}
                                                options={paymentTypeData}
                                                showSearch
                                            />
                                        </Form.Item>
                                    </Col>

                                    <Col span={24} style={{ padding: "0px 8px" }}>
                                        <Collapse
                                            ghost={ghost}
                                            items={Items}
                                            bordered={false}
                                            expandIconPosition={"end"}
                                            style={{ padding: "0px", marginBottom: 15, marginTop: 15 }}
                                            expandIcon={({ isActive }) => {
                                                {
                                                    isActive ? setGhost(false) : setGhost(true);
                                                }
                                                return (
                                                    <>
                                                        {isActive ? (
                                                            <MinusOutlined
                                                                style={{
                                                                    backgroundColor: "#15CCAE",
                                                                    color: "white",
                                                                    padding: 8,
                                                                    borderRadius: 10,
                                                                }}
                                                            />
                                                        ) : (
                                                            <PlusOutlined
                                                                style={{
                                                                    backgroundColor: "#15CCAE",
                                                                    color: "white",
                                                                    padding: 8,
                                                                    borderRadius: 10,
                                                                }}
                                                            />
                                                        )}
                                                    </>
                                                );
                                            }}
                                        />
                                    </Col>
                                    {isTransferToSavingsSelected &&
                                        <>
                                            <Col span={8} style={{ padding: "0px 8px" }}>
                                                <Form.Item
                                                    label={labelConfig.transferToSavings}
                                                    name="transferToSavings"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: BOM.CheckReqFld(labelConfig.transferToSavings),
                                                        },
                                                    ]}
                                                >
                                                    <Select
                                                        filterOption={(input, option) =>
                                                            (option?.label?.toLowerCase() ?? "").includes(
                                                                input?.toLowerCase()
                                                            )
                                                        }
                                                        placeholder={BOM.handlePlaceholderMsg(
                                                            labelConfig.transferToSavings,
                                                            "select"
                                                        )}
                                                        options={transferToSavingsOptions}
                                                        showSearch
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col span={8} style={{ padding: "0px 8px" }}>
                                                <Form.Item
                                                    label={labelConfig.transferDescription}
                                                    name="transferDescription"
                                                >
                                                    <TextArea rows={3} />
                                                </Form.Item>
                                            </Col>

                                        </>
                                    }
                                    <Col span={8} style={{ padding: "0px 8px" }}>
                                        <Form.Item
                                            label={labelConfig.note}
                                            name="note"
                                        >
                                            <TextArea rows={3} />
                                        </Form.Item>
                                    </Col>
                                </>
                            }
                        </Row>

                        <Row>
                            <Divider />
                            <CustomButton
                                content={`${isDateSubmitted ? "Submit" : "Next"}`}
                                style={{
                                    width: "10%",
                                    marginLeft: "auto",
                                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                                }}
                                htmlType="submit"
                                backgroundColor="#15CCAE"
                                colorText="black"
                                hoverBackground="#4FECA0"
                            />
                            <CustomButton
                                content="Cancel"
                                style={{
                                    width: "10%",
                                    marginLeft: "1%",
                                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                                }}
                                backgroundColor="#fff"
                                colorText="black"
                                hoverBackground="#F5F5F5"
                                onClick={onCancel}
                            />
                        </Row>
                    </Form>
                </Card>
            </Spin>
        </MainLayout>
    );
};

export default PrematureCloseRecurringDepositAcc;
